const GetUserLocationSubDetails = ({ data }) => {
    const { action } = data;

    const titleObject = action.find((obj) => obj.name === 'Title');
    const subheadingObject = action.find((obj) => obj.name === 'Subheading');

    return (
        <>
            <p className="flex gap-1 text-xs text-textSecondary mb-2  ">
                <span>Response type : </span>{' '}
                <span className="font-bold capitalize ">{data?.label?.split('_')?.join(' ')?.toLowerCase()}</span>
            </p>
            <p className="font-semibold capitalize text-textPrimary mb-2">
                <span>{titleObject?.value}</span>
            </p>
            <p className="text-sm capitalize text-textPrimary mb-2">
                <span>{subheadingObject?.value}</span>
            </p>
        </>
    );
};

export default GetUserLocationSubDetails;
